/* eslint-disable @typescript-eslint/no-explicit-any */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { THEME_STORE } from '../indexedDB/indexed-db-config';

type TMapTile =
  | 'OSM Light'
  | 'OSM Standard'
  | 'OSM France'
  | 'OSM Humanitarian'
  | 'CyclOSM'
  | 'OpenTopoMap'
  | 'World Imagery'
  | 'Live Traffic Azure';

type TThemeStore = {
  mapTile: TMapTile;
  setMapTile: (value: TMapTile) => void;
  reset: () => void;
};

const useThemeStore = create<TThemeStore>()(
  persist(
    (set) => ({
      mapTile: 'OSM Light',
      setMapTile: (val: TMapTile) => set(() => ({ mapTile: val })),
      reset: () =>
        set(() => ({
          mapTile: 'OSM Light',
        })),
    }),
    {
      name: THEME_STORE,
    }
  )
);

export default useThemeStore;
